import React from 'react';
import { mockData } from '../data/mock';
import { Award, Users, TrendingUp } from 'lucide-react';

const TrustBadges = () => {
  return (
    <section className="py-20 px-4 bg-gray-50">
      <div className="container mx-auto max-w-6xl">
        {/* Client Logos */}
        <div className="mb-20">
          <h3 className="text-center text-sm font-semibold text-gray-600 mb-8 uppercase tracking-wider">
            Trusted by Leading Organizations
          </h3>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
            {mockData.clients.map((client, index) => (
              <div 
                key={index} 
                className="flex items-center justify-center p-6 bg-white rounded-lg hover:shadow-md transition-shadow"
              >
                <div className="text-center">
                  <div className="w-16 h-16 bg-card-lime rounded-full flex items-center justify-center mx-auto mb-2">
                    <span className="font-bold text-xl text-black">{client.logo}</span>
                  </div>
                  <p className="text-xs text-gray-600 font-medium">{client.name}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Key Metrics */}
        <div className="grid md:grid-cols-3 gap-8 mb-20">
          <div className="text-center p-8 bg-white rounded-lg">
            <div className="w-16 h-16 bg-black rounded-full flex items-center justify-center mx-auto mb-4">
              <Users className="text-white" size={32} />
            </div>
            <div className="font-serif text-4xl font-bold text-black mb-2">250+</div>
            <p className="text-gray-600 font-medium">Satisfied Clients</p>
          </div>
          <div className="text-center p-8 bg-white rounded-lg">
            <div className="w-16 h-16 bg-black rounded-full flex items-center justify-center mx-auto mb-4">
              <TrendingUp className="text-white" size={32} />
            </div>
            <div className="font-serif text-4xl font-bold text-black mb-2">500+</div>
            <p className="text-gray-600 font-medium">Projects Completed</p>
          </div>
          <div className="text-center p-8 bg-white rounded-lg">
            <div className="w-16 h-16 bg-black rounded-full flex items-center justify-center mx-auto mb-4">
              <Award className="text-white" size={32} />
            </div>
            <div className="font-serif text-4xl font-bold text-black mb-2">99%</div>
            <p className="text-gray-600 font-medium">Client Satisfaction</p>
          </div>
        </div>

        {/* Awards */}
        <div className="text-center">
          <h3 className="font-serif text-3xl font-bold text-black mb-8">
            Award-Winning Work
          </h3>
          <div className="grid md:grid-cols-3 gap-6">
            {mockData.awards.map((award, index) => (
              <div key={index} className="bg-card-lime p-6 rounded-lg">
                <Award className="mx-auto mb-3 text-black" size={32} />
                <h4 className="font-semibold text-black mb-1">{award.title}</h4>
                <p className="text-sm text-gray-700">{award.organization}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default TrustBadges;
